import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import * as styles from './index.module.scss';

export type Props = {
  body: string;
  isWarning?: boolean;
  visible: boolean;
  onClose?: () => void;
};

export const FlashMessage: React.FC<Props> = ({
  body,
  isWarning = false,
  visible,
  onClose,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 800);
    } else if (shouldRender) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
        setShouldRender(false);
      }, 800);
    }
  }, [visible, shouldRender]);

  if (!shouldRender && !isAnimating) return null;
  if (!body) return null;

  const wrapperClasses = classNames(styles.messageWrapper, {
    [styles.visible]: visible,
    [styles.animating]: isAnimating,
    [styles.hidden]: !shouldRender && !isAnimating,
    [styles.warning]: isWarning,
    [styles.success]: !isWarning,
  });

  const messageClasses = classNames(styles.message, {
    [styles.warning]: isWarning,
    [styles.success]: !isWarning,
  });

  return (
    <div
      className={wrapperClasses}
      data-testid={isWarning ? 'error-message' : 'success-message'}
    >
      <div className={messageClasses}>
        {body}
        {onClose && (
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};
